import styled from 'styled-components'
import { Row } from '@sainsburys-tech/bolt'

export const MobileWrapper = styled(Row)`
  && {
    flex-flow: column nowrap;
  }
`
